function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M42.3785 15.0057C42.6832 15.2714 42.9269 15.5998 43.093 15.9683C43.2591 16.3369 43.3437 16.737 43.3409 17.1413V29.8889C43.3236 30.7445 42.9716 31.5592 42.3603 32.1582C41.7491 32.7571 40.9273 33.0925 40.0716 33.0923H39.2806",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.7345 33.0923H5.9548C5.09448 33.0994 4.26602 32.7671 3.64908 32.1674C3.03214 31.5678 2.67645 30.7491 2.65913 29.8889V17.5499C2.65912 17.1184 2.74455 16.6911 2.91049 16.2927C3.07644 15.8943 3.31961 15.5327 3.62599 15.2288C3.93237 14.9249 4.2959 14.6846 4.6956 14.5219C5.09529 14.3591 5.52326 14.2771 5.9548 14.2806H25.9397",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4953 19.936L10.6742 27.661L7.83993 19.936",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M25.887 19.936V27.661L20.2448 19.936V27.661",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M16.8701 19.936V27.661",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M34.0075 30.7722C33.4761 30.7722 32.9664 30.9833 32.5907 31.359C32.2149 31.7348 32.0038 32.2445 32.0038 32.7759V32.7759C32.0956 33.2327 32.3427 33.6436 32.7032 33.9389C33.0637 34.2341 33.5152 34.3954 33.9812 34.3954C34.4471 34.3954 34.8987 34.2341 35.2592 33.9389C35.6196 33.6436 35.8668 33.2327 35.9586 32.7759V32.7759C35.9555 32.2545 35.7505 31.7546 35.3868 31.381C35.023 31.0074 34.5287 30.7892 34.0075 30.7722V30.7722Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M34.2448 12.6591C33.0853 12.6146 31.938 12.9088 30.943 13.5057C29.948 14.1027 29.1485 14.9767 28.6422 16.0207C28.4889 16.4492 28.5043 16.92 28.6853 17.3376C28.8663 17.7552 29.1993 18.0883 29.6169 18.2694C30.0344 18.4505 30.5052 18.466 30.9337 18.3128C31.3623 18.1596 31.7166 17.8492 31.9247 17.4444C32.1447 17.0315 32.4765 16.6889 32.8821 16.4557C33.2878 16.2226 33.7509 16.1084 34.2185 16.1262C34.5301 16.1117 34.8413 16.1613 35.133 16.2719C35.4247 16.3825 35.6906 16.5518 35.9142 16.7693C36.1378 16.9867 36.3145 17.2478 36.4332 17.5362C36.552 17.8247 36.6103 18.1344 36.6045 18.4463C36.6045 19.7646 35.7476 20.371 34.7721 21.0829C33.9472 21.5308 33.2635 22.1999 32.7977 23.0149C32.332 23.8299 32.1027 24.7587 32.1356 25.6968V25.9341C32.1356 26.4376 32.3356 26.9204 32.6916 27.2764C33.0476 27.6324 33.5304 27.8324 34.0339 27.8324C34.5374 27.8324 35.0202 27.6324 35.3762 27.2764C35.7322 26.9204 35.9322 26.4376 35.9322 25.9341V25.6968C35.9322 24.3126 36.8154 23.6403 37.791 22.8757C38.5604 22.4254 39.1972 21.7798 39.637 21.0043C40.0768 20.2289 40.304 19.351 40.2957 18.4595C40.3079 17.673 40.1577 16.8924 39.8547 16.1665C39.5516 15.4407 39.1021 14.7851 38.5342 14.2407C37.9664 13.6964 37.2924 13.275 36.5544 13.0029C35.8163 12.7307 35.0301 12.6137 34.2448 12.6591V12.6591Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgVinNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVinNotFound);
export default __webpack_public_path__ + "static/media/vin-not-found.c0cfec2b72d001fdb9d2f5384226e1d7.svg";
export { ForwardRef as ReactComponent };